import React from 'react';
import { Link } from 'react-router-dom';

// Placeholder video categories — replace videoId with actual YouTube IDs
const categories = [
  {
    name: "Teachings",
    videos: [
      { id: 'v1', title: 'How to Make a DECISION', videoId: '713BHz_wOBg' },
      { id: 'v2', title: 'Stop Sleep Walking in Your LIFE', videoId: 'McHOQqRXiR8' },
    ],
  },
  {
    name: "Conversations",
    videos: [
      { id: 'v3', title: 'On My WAY HERE... Live on Stage with Les Brown', videoId: 'YdUtfQ3otkg' },
      { id: 'v4', title: 'A Conversation with Yvette Jones Johnson — How to Be a Change Maker in Your Life', videoId: 'xKn_g5NVXNQ' },
    ],
  },
  {
    name: "GangstaChef Kitchen",
    videos: [
      { id: 'v5', title: 'How to Make GangstaGarlic Chili Oil', videoId: '97tIDd3o86c' },
      { id: 'v6', title: 'How to Make Salmon Cabbage Cakes', videoId: 'fqiMw6Najlo' },
    ],
  },
];

function VideoCard({ videoId, title }) {
  if (!videoId) {
    return (
      <div className="tv-video-placeholder">
        <div className="tv-video-inner">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <polygon points="5 3 19 12 5 21 5 3" fill="currentColor" />
          </svg>
          <span>Coming soon</span>
        </div>
      </div>
    );
  }
  return (
    <div className="tv-video-embed">
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}

export default function VillageTVPage() {
  return (
    <section data-testid="village-tv-page" className="village-tv-page">
      <div className="tv-hero">
        <h1 data-testid="tv-title" className="tv-title">Alchemy Village TV</h1>
        <p className="tv-subtitle">Teachings, stories, and experiences from The Alchemy Village</p>
      </div>

      <div className="tv-content">
        {categories.map((cat) => (
          <div key={cat.name} className="tv-category" data-testid={`tv-category-${cat.name.toLowerCase().replace(/\s+/g, '-')}`}>
            <h2 className="tv-category-title">{cat.name}</h2>
            <div className="tv-grid">
              {cat.videos.map((v) => (
                <div key={v.id} className="tv-card" data-testid={`tv-card-${v.id}`}>
                  <VideoCard videoId={v.videoId} title={v.title} />
                  <h3 className="tv-card-title">{v.title}</h3>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="tv-cta">
          <Link to="/life-map" className="village-btn village-btn--secondary">
            Back to Life-Map
          </Link>
        </div>
      </div>
    </section>
  );
}
